export const calendars = {
  blue: {
    label: 'blue',
    colorName: 'blue',
    lightColors: {
      main: '#8ecbff',
      container: '#b3d9ff',
      onContainer: '#004f73'
    },
    darkColors: {
      main: '#a2c4d5',
      onContainer: '#e0f7ff',
      container: '#678f9b'
    }
  },
  orange: {
    label: 'orange',
    colorName: 'orange',
    lightColors: {
      main: '#ffb347',
      container: '#ffd9a1',
      onContainer: '#9c6b30'
    },
    darkColors: {
      main: '#ffcc80',
      onContainer: '#ffe0b2',
      container: '#a6641a'
    }
  },
  pink: {
    label: 'pink',
    colorName: 'pink',
    lightColors: {
      main: '#ffb6c1',
      container: '#ffdfdf',
      onContainer: '#cc5280'
    },
    darkColors: {
      main: '#f3c6d8',
      onContainer: '#ffecf1',
      container: '#d19fa1'
    }
  },
  green: {
    label: 'green',
    colorName: 'green',
    lightColors: {
      main: '#a8e6cf',
      container: '#d0f9e6',
      onContainer: '#4b6b35'
    },
    darkColors: {
      main: '#c1e7d8',
      onContainer: '#d0f3e7',
      container: '#72a671'
    }
  },
  purple: {
    label: 'purple',
    colorName: 'purple',
    lightColors: {
      main: '#cda4de',
      container: '#e5c0e6',
      onContainer: '#602a5f'
    },
    darkColors: {
      main: '#b497d8',
      onContainer: '#e8daf3',
      container: '#754d88'
    }
  },
  yellow: {
    label: 'yellow',
    colorName: 'yellow',
    lightColors: {
      main: '#fff8b3',
      container: '#fffbcf',
      onContainer: '#b6b33a'
    },
    darkColors: {
      main: '#f1e38f',
      onContainer: '#fff8d8',
      container: '#c6a73c'
    }
  },
  teal: {
    label: 'teal',
    colorName: 'teal',
    lightColors: {
      main: '#7bd2d6',
      container: '#a8e0e5',
      onContainer: '#3f6a6d'
    },
    darkColors: {
      main: '#5ab2b2',
      onContainer: '#d0f2f3',
      container: '#4b797d'
    }
  },
  peach: {
    label: 'peach',
    colorName: 'peach',
    lightColors: {
      main: '#ffcc99',
      container: '#ffe0b3',
      onContainer: '#b35d33'
    },
    darkColors: {
      main: '#f0c18c',
      onContainer: '#ffe7c6',
      container: '#a74e2e'
    }
  },
  mint: {
    label: 'mint',
    colorName: 'mint',
    lightColors: {
      main: '#b2f0e6',
      container: '#d9f7f3',
      onContainer: '#3a6b63'
    },
    darkColors: {
      main: '#a5d8b1',
      onContainer: '#e5f8f2',
      container: '#597c69'
    }
  },
  lavender: {
    label: 'lavender',
    colorName: 'lavender',
    lightColors: {
      main: '#b19cd9',
      container: '#e4d1f9',
      onContainer: '#6a4f88'
    },
    darkColors: {
      main: '#9a8cb7',
      onContainer: '#f0e6ff',
      container: '#7d5e8c'
    }
  },
  coral: {
    label: 'coral',
    colorName: 'coral',
    lightColors: {
      main: '#ff7f50',
      container: '#ff9e80',
      onContainer: '#b45533'
    },
    darkColors: {
      main: '#ff8566',
      onContainer: '#ffb39d',
      container: '#8f634d'
    }
  },
  lavenderBlue: {
    label: 'lavenderBlue',
    colorName: 'lavenderBlue',
    lightColors: {
      main: '#a1a8c2',
      container: '#d0d5e3',
      onContainer: '#4f5073'
    },
    darkColors: {
      main: '#7f8fa6',
      onContainer: '#f0f2fb',
      container: '#5f6277'
    }
  },
  skyBlue: {
    label: 'skyBlue',
    colorName: 'skyBlue',
    lightColors: {
      main: '#87ceeb',
      container: '#bde1f7',
      onContainer: '#4d8b9b'
    },
    darkColors: {
      main: '#72a3b9',
      onContainer: '#d3e6f9',
      container: '#56828b'
    }
  },
  lightPink: {
    label: 'lightPink',
    colorName: 'lightPink',
    lightColors: {
      main: '#ffb3d9',
      container: '#ffc9e2',
      onContainer: '#9c5c6d'
    },
    darkColors: {
      main: '#f1a6c1',
      onContainer: '#ffe0f0',
      container: '#a77c8c'
    }
  },
  lightYellow: {
    label: 'lightYellow',
    colorName: 'lightYellow',
    lightColors: {
      main: '#ffffb3',
      container: '#ffffcc',
      onContainer: '#b3b31a'
    },
    darkColors: {
      main: '#f2f1a3',
      onContainer: '#fff9d8',
      container: '#9a9a35'
    }
  },
  lightGreen: {
    label: 'lightGreen',
    colorName: 'lightGreen',
    lightColors: {
      main: '#c7f0b5',
      container: '#e1fad2',
      onContainer: '#5a7d3c'
    },
    darkColors: {
      main: '#b8e59f',
      onContainer: '#d9f3db',
      container: '#5d7f3a'
    }
  },
  lightPurple: {
    label: 'lightPurple',
    colorName: 'lightPurple',
    lightColors: {
      main: '#e3b8f2',
      container: '#e6d1f9',
      onContainer: '#7f3c9a'
    },
    darkColors: {
      main: '#d29fe3',
      onContainer: '#f1d9ff',
      container: '#8c4e8f'
    }
  },
  lightTeal: {
    label: 'lightTeal',
    colorName: 'lightTeal',
    lightColors: {
      main: '#b3d9d9',
      container: '#c1e6e6',
      onContainer: '#4a6d6d'
    },
    darkColors: {
      main: '#9fc0c0',
      onContainer: '#c9e4e4',
      container: '#5f7c7c'
    }
  },
  salmon: {
    label: 'salmon',
    colorName: 'salmon',
    lightColors: {
      main: '#ffb3a7',
      container: '#ffc2b3',
      onContainer: '#9e544d'
    },
    darkColors: {
      main: '#f2a19e',
      onContainer: '#ffd1cd',
      container: '#8f6250'
    }
  },
  peachyPink: {
    label: 'peachyPink',
    colorName: 'peachyPink',
    lightColors: {
      main: '#ffbfa6',
      container: '#ffccbb',
      onContainer: '#9f6b48'
    },
    darkColors: {
      main: '#f4a182',
      onContainer: '#ffd4b3',
      container: '#7f5a3c'
    }
  },
  pastelRed: {
    label: 'pastelRed',
    colorName: 'pastelRed',
    lightColors: {
      main: '#ff7a7a',
      container: '#ffb2b2',
      onContainer: '#a63333'
    },
    darkColors: {
      main: '#f18c8c',
      onContainer: '#ffdbdb',
      container: '#9b5454'
    }
  },
  blush: {
    label: 'blush',
    colorName: 'blush',
    lightColors: {
      main: '#f8d4d7',
      container: '#f9e0e2',
      onContainer: '#ba6a6d'
    },
    darkColors: {
      main: '#f5c1c6',
      onContainer: '#fce2e7',
      container: '#9d5d5f'
    }
  }
};

export const getRandomColor = () => {
  const colorKeys = Object.keys(calendars);
  const randomKey = colorKeys[Math.floor(Math.random() * colorKeys.length)];
  return calendars[randomKey];
};
